var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassportSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 6.99805V20.9937",
    stroke: "#171C60",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99962 17.9944C2.7345 17.9944 2.48025 17.889 2.29278 17.7016C2.10532 17.5141 2 17.2598 2 16.9947V3.99871C2 3.73358 2.10532 3.4793 2.29278 3.29183C2.48025 3.10435 2.7345 2.99902 2.99962 2.99902H7.99772C9.05818 2.99902 10.0752 3.42032 10.8251 4.17023C11.5749 4.92014 11.9962 5.93724 11.9962 6.99778C11.9962 5.93724 12.4175 4.92014 13.1673 4.17023C13.9172 3.42032 14.9342 2.99902 15.9947 2.99902H20.9928C21.2579 2.99902 21.5121 3.10435 21.6996 3.29183C21.8871 3.4793 21.9924 3.73358 21.9924 3.99871V16.9947C21.9924 17.2598 21.8871 17.5141 21.6996 17.7016C21.5121 17.889 21.2579 17.9944 20.9928 17.9944H14.9951C14.1997 17.9944 13.4369 18.3103 12.8745 18.8728C12.3121 19.4352 11.9962 20.198 11.9962 20.9934C11.9962 20.198 11.6802 19.4352 11.1178 18.8728C10.5555 18.3103 9.79268 17.9944 8.99734 17.9944H2.99962Z",
    stroke: "#171C60",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassportSmall);
export default __webpack_public_path__ + "static/media/icon_passport_small.da0b02a1949210a5b77cc634b00724b5.svg";
export { ForwardRef as ReactComponent };